import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const TournamentsFilter = ({
    tournaments,
    loading,
    //disabled because of LiveControlFilters.jsx && EventScheduleFilters.jsx && LcppClientNotificationLogFilters.jsx
    disabled = false,
    filters,
    restoreFilterValues,
    hidden = false,
    onChangeValue = null,
}) => {
    return (
        <Field
            component={Form.ReduxSelect}
            name='tournaments'
            options={tournaments}
            disabled={disabled || loading}
            setValue={restoreFilterValues(filters, 'tournaments') ?? ''}
            placeholder='Tournament'
            loading={loading}
            className='long'
            hidden={hidden}
            search
            multiple
            selection
            onChangeValue={onChangeValue}
        />
    );
};

TournamentsFilter.propTypes = {
    tournaments: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
    onChangeValue: PropTypes.func,
};
